try { window.$ = window.jQuery = require('jquery'); } catch (e) {}
window._ = require('lodash');
window.Vue = require('../node_modules/vue/dist/vue.min.js');
window.axios = require('axios');

//Libraries
// require('../static/bootstrap4/lib/jquery-3.3.1.min.js');
// require('../static/bootstrap4/lib/jquery-ui/jquery-ui.min.js');
// require('../static/bootstrap4/lib/bootstrap.bundle.min.js');
// require('../static/bootstrap4/lib/slick/slick.min.js');
// require('../static/bootstrap4/lib/photoswipe/photoswipe.min.js');
// require('../static/bootstrap4/lib/photoswipe/photoswipe-ui-default.min.js');
// require('../static/bootstrap4/lib/parsley.min.js');
// require('../static/bootstrap4/js/main/global.js');
// require('../static/bootstrap4/js/main/header.js');
// require('../static/bootstrap4/js/main/banner.js');
// require('../static/bootstrap4/js/main/sidebar.js');
// require('../static/bootstrap4/js/main/weather.js');
// require('../static/bootstrap4/js/main/autocomplete.js');
// require('../static/bootstrap4/js/main/business-search.js');
// require('../static/bootstrap4/js/main/lob/business-listings.js');
// require('../static/bootstrap4/js/main/lob/business-registration.js');


// WEBPACK FOOTER //
// ./src/bootstrap.js